module.exports = __webpack_public_path__ + "images/tour/photos_actions-74daabcf5daae74896380b7f35206b06.gif";